import { createContext, useContext } from "react";

import type {
  AllSelectedData,
  DisplayedProgramTemplate,
} from "containers/admin/clients/client/program-templates-page/components/program-templates-table/program-templates-table.helper";

type ProgramTemplatesSelection = {
  allSelectedData: AllSelectedData[];
  setAllSelectedData: (allSelectedData: AllSelectedData[]) => void;
  displayedTemplates: DisplayedProgramTemplate[];
};

/**
 * Selection reaches the checkbox cells through context rather than through the column definitions:
 * `flexRender` mounts a column's `cell` as a component, so a column rebuilt on every selection change
 * remounts every row of this unpaged table — action menus, their modals and forms included.
 */
export const ProgramTemplatesSelectionContext = createContext<ProgramTemplatesSelection | null>(null);

export const useProgramTemplatesSelection = (): ProgramTemplatesSelection => {
  const selection = useContext(ProgramTemplatesSelectionContext);

  if (!selection) {
    throw new Error("useProgramTemplatesSelection must be used within ProgramTemplatesTable");
  }

  return selection;
};
